import { SimpleTagPickerExample } from "./examples/TagPicker.Simple.Example";
import { AsyncTagPickerExample } from "./examples/TagPicker.Async.Example";

export default [
    {
        title: "Basic tag picker",
        component: SimpleTagPickerExample,
        code: require("!raw-loader!./examples/TagPicker.Simple.Example.tsx"),
        stretchContainer: true
    },
    {
        title: "Async tag picker",
        component: AsyncTagPickerExample,
        code: require("!raw-loader!./examples/TagPicker.Async.Example.tsx"),
        stretchContainer: true
    }
];
